export default "__VITE_ASSET__d9faf555__"